(() => {
  const variant = document.querySelector('[data-fs-landing][data-landing-variant]')?.dataset.landingVariant
  if (!['FS-LP1-PUPPYPAD-PRESS-TEST', 'FS-LP2-HIKE-OWN-ARTWORK-CHECKLIST', 'FS-LP4-JAVVY-OWN-ART-11'].includes(variant)) return
  const funnel = document.querySelector('[data-dtfs-free-sample]')
  const question = document.querySelector('#dtfs-fs-question')
  const focusQuestion = () => {
    if (!question) return
    if (!question.hasAttribute('tabindex')) question.setAttribute('tabindex', '-1')
    question.focus({ preventScroll: true })
  }
  let answerFocus = null
  let previousScreen = funnel?.dataset.currentScreen
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return
    if (event.target.closest('[data-fs-funnel-cta]')) requestAnimationFrame(focusQuestion)
    const answer = event.target.closest('[data-answer="experience"]')
    if (answer) answerFocus = answer
  })
  let restoreAnswer = false
  let focusFrame = 0
  if (funnel) new MutationObserver(() => {
    const screen = funnel.dataset.currentScreen
    if (screen === 'experience' && previousScreen && previousScreen !== screen) restoreAnswer = true
    if (screen !== 'experience') restoreAnswer = false
    previousScreen = screen
    const entry = funnel.querySelector('[data-screen="experience"]')
    if (!restoreAnswer || focusFrame || entry?.hidden || entry?.classList.contains('is-transitioning') || funnel.classList.contains('is-entry-moving')) return
    focusFrame = requestAnimationFrame(() => {
      focusFrame = requestAnimationFrame(() => {
        focusFrame = 0
        if (!restoreAnswer || funnel.dataset.currentScreen !== 'experience' || entry?.hidden || entry?.classList.contains('is-transitioning') || funnel.classList.contains('is-entry-moving')) return
        restoreAnswer = false
        if (answerFocus?.isConnected) answerFocus.focus({ preventScroll: true })
        else focusQuestion()
      })
    })
  }).observe(funnel, { attributes: true, subtree: true, attributeFilter: ['data-current-screen', 'class', 'hidden'] })

  const roots = [document.documentElement, document.body]
  const properties = ['overflow', 'overflow-x', 'overflow-y']
  const snapshot = () => roots.map(root => properties.map(name => ({ name, value: root.style.getPropertyValue(name), priority: root.style.getPropertyPriority(name) })))
  const locked = root => ['hidden', 'clip'].includes(getComputedStyle(root).overflowY)
  const isKlaviyo = element => Boolean(element.matches('[class*="kl-private-reset-css"]') || element.closest('[class*="kl-private-reset-css"], [class*="klaviyo-form"]'))
  const dialogs = () => [...document.querySelectorAll('[role="dialog"], [aria-modal="true"], dialog[open]')]
  const visible = element => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
  let baseline = snapshot()
  let recoverable = roots.map(root => !locked(root))
  let closing = null
  let frame = 0
  const attempted = new WeakSet()
  const restore = () => {
    roots.forEach((root, index) => {
      const klaviyoLock = root.classList.contains('klaviyo-prevent-body-scrolling')
      if (klaviyoLock) root.classList.remove('klaviyo-prevent-body-scrolling')
      if ((!recoverable[index] && !klaviyoLock) || !locked(root)) return
      properties.forEach(name => root.style.removeProperty(name))
      baseline[index].forEach(({ name, value, priority }) => { if (value) root.style.setProperty(name, value, priority) })
    })
  }
  const check = () => {
    frame = 0
    const current = dialogs()
    if (current.some(dialog => !isKlaviyo(dialog) && visible(dialog))) return
    if (closing && (!closing.isConnected || !visible(closing))) {
      restore()
      closing = null
    }
    const popup = current.find(dialog => isKlaviyo(dialog) && visible(dialog))
    if (popup && !attempted.has(popup)) {
      const close = popup.querySelector('button[aria-label*="close" i], button[title*="close" i], [data-testid="close-button"]')
      if (close) {
        attempted.add(popup)
        closing = popup
        close.click()
        window.setTimeout(schedule, 350)
      }
    }
    if (!popup && !closing && roots.every(root => !locked(root))) {
      baseline = snapshot()
      recoverable = [true, true]
    }
  }
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(check)
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'open'] })
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] })
  window.addEventListener('klaviyoForms', schedule)
  check()
})()
